import { useTranslation } from 'react-i18next';

import {
  AIRevisionStatus,
  revisionStatusDetails,
} from '../../../../constants/MemoryGames/aiRevision';
import {
  ScrollArrows,
  StationCell,
  StationCellProps,
} from '../../../Molecules';

import styles from './AIRevisionGamesListTemplate.module.css';

type AIRevisionGamesListTemplateProps = {
  type: AIRevisionStatus;
  items: StationCellProps[];
  onClickBoostAll?: () => void;
};

export const AIRevisionGamesListTemplate = (
  props: AIRevisionGamesListTemplateProps,
) => {
  const { items, type, onClickBoostAll } = props;
  const { t } = useTranslation();
  const title = revisionStatusDetails[type].displayName;
  return (
    <>
      <div className={styles.aiRevisionGameList}>
        <div className={styles.container}>
          {items.length >= 10 && <ScrollArrows />}
          <p className={styles.title}>{t(title)}</p>

          {type === AIRevisionStatus.Ready && (
            <p className={styles.subtitle}>
              {t('Select the Practice to boost memory retention by up to 9x.')}
            </p>
          )}

          <div className={styles.gameList}>
            {items.map((item, index) => (
              <StationCell key={index} {...item} />
            ))}
          </div>
        </div>
      </div>
      {onClickBoostAll && type === AIRevisionStatus.Ready && (
        <div className={styles.stickyButtonContainer}>
          <button className={styles.button} onClick={onClickBoostAll}>
            {t('Boost Memory of All Practice Up to 9x')}
          </button>
        </div>
      )}
    </>
  );
};
